import { useMemo } from "react";

import { AppointmentSlot, Provider } from "~/services";
import { TimeZone } from "~/shared.types";
import { formatDateKey } from "~/utils";
import { convertTimeToTimeZone, TIMEZONES } from "../utils/date-time-utils";

export const convertSlotsToTimeZone = (
  slots: AppointmentSlot[] | undefined,
  targetTimeZone: string,
  referenceDate: Date,
): Array<AppointmentSlot & { originalTime: string }> => {
  if (!slots || slots.length === 0) {
    return [];
  }
  return slots.map((slot) => {
    const convertedTime = convertTimeToTimeZone(
      slot.startTime,
      TIMEZONES.ET.code,
      targetTimeZone,
      referenceDate,
    );

    return {
      ...slot,
      startTime: convertedTime,
      originalTime: slot.startTime,
    };
  });
};

export const useTimeZoneConversion = (
  providers: Provider[],
  selectedTimeZone: TimeZone,
  selectedDate: Date,
) => {
  const convertedProviders = useMemo(() => {
    const dateString = formatDateKey(selectedDate);

    return providers.map((provider) => ({
      ...provider,
      slots: {
        [dateString]: convertSlotsToTimeZone(
          provider.slots[dateString] || [],
          selectedTimeZone.code,
          selectedDate,
        ),
      },
    }));
  }, [providers, selectedTimeZone, selectedDate]);

  return convertedProviders;
};
